import Link from "next/link";
import type React from "react";
import { LogoIcon } from "@/components/logo-icon";

const links = [
  {
    group: "Platform",
    items: [
      { title: "Find jobs", href: "/job-listings" },
      { title: "Post jobs", href: "/jobs?modal=create-job" },
      { title: "Testimonials", href: "#testimonials" },
      { title: "Roadmap", href: "#roadmap" },
    ],
  },
  {
    group: "Company",
    items: [
      // { title: 'About us', href: '#' },
      // { title: 'Blog', href: '#' },
      { title: "Privacy policy", href: "/privacy" },
      { title: "Terms of service", href: "/terms" },
    ],
  },
  {
    group: "Community",
    items: [
      // {
      //   title: 'Join our slack',
      //   href: '#',
      // },
      // {
      //   title: 'GitHub',
      //   href: '#',
      // },
      {
        title: "LinkedIn",
        href: "https://www.linkedin.com/company/vacwork",
      },
      {
        title: "Facebook",
        href: "https://www.facebook.com/profile.php?id=61551570253299",
      },
      {
        title: "X / twitter",
        href: "#",
      },
      {
        title: "Instagram",
        href: "https://www.instagram.com/vacwork.app/",
      },
    ],
  },
  {
    group: "Support",
    items: [{ title: "Contact", href: "mailto:admin@vacwork.app" }],
  },
];

const FooterLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <Link
    className="text-muted-foreground text-sm transition-colors hover:text-foreground"
    href={href}
  >
    {children}
  </Link>
);

export function FooterSection() {
  return (
    <footer className="mt-16 flex w-full flex-col items-center border-border border-t py-16">
      <div className="mr-auto max-w-6xl px-4 sm:px-6 md:mx-auto md:px-8">
        <div className="grid w-full grid-cols-1 gap-12 text-left md:grid-cols-2 md:gap-16 lg:grid-cols-6">
          <div className="flex flex-1 flex-col gap-y-6 md:col-span-2">
            <LogoIcon />
            <span
              className="w-full grow text-muted-foreground text-sm"
              suppressHydrationWarning
            >
              &copy; VacWork Inc. {new Date().getFullYear()}
            </span>
          </div>

          {links.map((section, index) => (
            <div
              className="flex flex-col gap-y-4 text-left"
              key={`${section.group}-${index}`}
            >
              <h3 className="font-medium text-base">{section.group}</h3>
              <div className="flex flex-col gap-y-2">
                {section.items.map((item) => (
                  <FooterLink
                    href={item.href}
                    key={`${item.title}-${item.href}`}
                  >
                    {item.title}
                  </FooterLink>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}
